import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=c924aef8&scoped=true&"
import script from "./TaskInfo.vue?vue&type=script&lang=js&"
export * from "./TaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=c924aef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c924aef8",
  null
  
)

export default component.exports